export const defaultScope = "va:mgnt";
export const accessScope = "va:mgnt:access";
export const updateProfileScope = "va:mgnt:account:profile:write";

export const scopeUsage = {
  accesssApiKeyPage: "va:mgnt:apikey:access",
  readApiKey: "va:mgnt:apikey:read",
  writeApiKey: "va:mgnt:apikey:write",
  accesssApplicationPage: "va:mgnt:application:access",
  readApplication: "va:mgnt:application:read",
  writeApplication: "va:mgnt:application:write",
  accesssUserPage: "va:mgnt:user:access",
  readUser: "va:mgnt:user:read",
  writeUser: "va:mgnt:user:write",
  accesssGroupPage: "va:mgnt:group:access",
  readGroup: "va:mgnt:group:read",
  writeGroup: "va:mgnt:group:write",
  readMemberGroup: "va:mgnt:group:users:read",
  writeMemberGroup: "va:mgnt:group:users:write",
  readAppGroup: "va:mgnt:group:applications:read",
  writeAppGroup: "va:mgnt:group:applications:write",
};
